import styles from "./Join_Ended.module.scss";

import { useCallback } from "react";

import { useNavigate } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";

import { BookNewSessionData } from "../../types/BookNewSessionData";

type Join_EndedProps = {
  bookNewSessionData: BookNewSessionData | null;
  sessionCode: string;
};

export function Join_Ended({
  bookNewSessionData,
  sessionCode,
}: Join_EndedProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnBookNewSessionClick = useCallback(() => {
    if (!bookNewSessionData) return;

    navigate({
      to: "/$sessionCode/book",
      params: { sessionCode },
    });
  }, [bookNewSessionData, navigate, sessionCode]);

  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>{t("coachingSession.ended.title")}</span>

        <Trans
          i18nKey="coachingSession.ended.description"
          components={{
            first: <p className={styles.description} />,
            second: <p className={styles.description} />,
          }}
        />

        <AppButton variant="critical" onClick={handleOnBookNewSessionClick}>
          <span>{t("coachingSession.ended.cta")}</span>
        </AppButton>
      </div>
    </PageContainer>
  );
}
